import { useEffect, useState } from "react";
import { parseRoute, routeToHash, type AppRoute } from "../shared/lib/routes";

export function navigate(route: AppRoute, replace = false): void {
  const hash = routeToHash(route);
  if (replace) {
    history.replaceState(null, "", hash);
    window.dispatchEvent(new HashChangeEvent("hashchange"));
  } else {
    window.location.hash = hash;
  }
}

export function useAppRoute(): AppRoute {
  const [route, setRoute] = useState(() => parseRoute(window.location.hash));
  useEffect(() => {
    const handle = () => setRoute(parseRoute(window.location.hash));
    window.addEventListener("hashchange", handle);
    if (!window.location.hash) navigate({ name: "chat" }, true);
    return () => window.removeEventListener("hashchange", handle);
  }, []);
  return route;
}
